import axios from "axios";
import { getApiConfig } from "../../apiConfig";

export async function DisableCustomQuestion(customQuestion, idcustomQuestion, modifiedBy) {
  try {
    const apiConfig = await getApiConfig();
    const req = `${apiConfig.BASE_URL}customquestion/${idcustomQuestion}`;

    const customQuestionPatch = {
      enabled: !customQuestion.enabled,
      modifiedBy: modifiedBy
    };


    const response = await axios.patch(req, customQuestionPatch, apiConfig.HEADERS_CONFIG, {
    });

    return response.data;
  } catch (error) {
    // Manejar el error
    throw error;
  }
}
